import { axiosBase } from 'utils';
/* Services */
export function branchnetworkListService() {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: '/branchnetwork',
  });
}

export function branchnetworkListByIdService(id) {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: '/branchnetwork/' + id,
  });
}

export function branchnetworkCreateService(values) {
  const axios = axiosBase.create();
  return axios({
    method: 'POST',
    url: '/branchnetwork',
    data: {
      company: values.company,
      branch: values.branch,
      user: values.user,

      email: values.email,
      reference_id: values.reference_id,

      subnet_range_from: values.subnet_range_from,
      subnet_range_to: values.subnet_range_to,
      subnet: values.subnet,
      subnetmask: values.subnetmask,
      gateway: values.gateway,
      publicip: values.publicip,
      publicsubnet: values.publicsubnet,
      publicnetmask: values.publicnetmask,
      publicgateway: values.publicgateway,

      smtpserver: values.smtpserver,
      smtpusername: values.smtpusername,
      smtppassword: values.smtppassword,
      dns1: values.dns1,
      dns2: values.dns2,

      reservedVlanStart: values.reservedVlanStart,
      reservedVlanEnd: values.reservedVlanEnd,

      nextvlanid: values.nextvlanid,

      nextpublicip: values.nextpublicip,

      qosoptions: values.qosoptions,
      corporatevlan: values.corporatevlan,
      printervlan: values.printervlan,

      unassignedvlan: values.unassignedvlan,
      voicevlan: values.voicevlan,
      clientfirewallvlan: values.clientfirewallvlan,

      guestvlan: values.guestvlan,
      managementvlan: values.managementvlan,
      mainvlan: values.mainvlan,

      directoryLogoUrl: values.directoryLogoUrl,
      directoryVideoUrl: values.directoryVideoUrl,
      directoryBackgroundBannerUrl: values.directoryBackgroundBannerUrl,
      directoryDisplayDevice: values.directoryDisplayDevice,
      directoryItemsPerSlide: values.directoryItemsPerSlide,
      directoryAutoplaySpeed: values.directoryAutoplaySpeed,

      hide_logo: values.hide_logo,
      hide_logout: values.hide_logout,
      navbar_current_mode: values.navbar_current_mode,
      navbar_color_light_mode: values.navbar_color_light_mode,
      navbar_color_dark_mode: values.navbar_color_dark_mode,
      apply_to_other_locations: values.apply_to_other_locations,
      isp_speed: values.isp_speed,
      default_bandwidth: values.default_bandwidth,
      status: values.status,

      email_user_wifi_details: values.email_user_wifi_details,
      public_location_name: values.public_location_name,
      browsing_phrase: values.browsing_phrase,
      additional_email_wifi_credential: values.additional_email_wifi_credential,
      additional_email_branch_client: values.additional_email_branch_client,
      email_logo_url: values.email_logo_url,
    },
  });
}

export function branchnetworkUpdateService(id, values) {
  const axios = axiosBase.create();
  return axios({
    method: 'PATCH',
    url: '/branchnetwork/' + id,
    data: {
      company: values.company,
      branch: values.branch,
      user: values.user,

      email: values.email,
      reference_id: values.reference_id,

      subnet_range_from: values.subnet_range_from,
      subnet_range_to: values.subnet_range_to,
      subnet: values.subnet,
      subnetmask: values.subnetmask,
      gateway: values.gateway,
      publicip: values.publicip,
      publicsubnet: values.publicsubnet,
      publicnetmask: values.publicnetmask,
      publicgateway: values.publicgateway,

      smtpserver: values.smtpserver,
      smtpusername: values.smtpusername,
      smtppassword: values.smtppassword,
      dns1: values.dns1,
      dns2: values.dns2,

      reservedVlanStart: values.reservedVlanStart,
      reservedVlanEnd: values.reservedVlanEnd,

      nextvlanid: values.nextvlanid,

      nextpublicip: values.nextpublicip,

      qosoptions: values.qosoptions,
      corporatevlan: values.corporatevlan,
      printervlan: values.printervlan,

      unassignedvlan: values.unassignedvlan,
      voicevlan: values.voicevlan,
      clientfirewallvlan: values.clientfirewallvlan,

      guestvlan: values.guestvlan,
      managementvlan: values.managementvlan,
      mainvlan: values.mainvlan,

      directoryLogoUrl: values.directoryLogoUrl,
      directoryVideoUrl: values.directoryVideoUrl,
      directoryBackgroundBannerUrl: values.directoryBackgroundBannerUrl,
      directoryDisplayDevice: values.directoryDisplayDevice,
      directoryItemsPerSlide: values.directoryItemsPerSlide,
      directoryAutoplaySpeed: values.directoryAutoplaySpeed,

      hide_logo: values.hide_logo,
      hide_logout: values.hide_logout,
      navbar_current_mode: values.navbar_current_mode,
      navbar_color_light_mode: values.navbar_color_light_mode,
      navbar_color_dark_mode: values.navbar_color_dark_mode,
      apply_to_other_locations: values.apply_to_other_locations,
      isp_speed: values.isp_speed,
      default_bandwidth: values.default_bandwidth,
      status: values.status,

      email_user_wifi_details: values.email_user_wifi_details,
      public_location_name: values.public_location_name,
      browsing_phrase: values.browsing_phrase,
      additional_email_wifi_credential: values.additional_email_wifi_credential,
      additional_email_branch_client: values.additional_email_branch_client,
      email_logo_url: values.email_logo_url,
    },
  });
}

export function branchnetworkDeleteService(id) {
  const axios = axiosBase.create();
  return axios({
    method: 'DELETE',
    url: '/branchnetwork/' + id,
  });
}

export function branchnetworkSearchService(q) {
  const axios = axiosBase.create();
  if (q === '') {
    return axios({
      method: 'GET',
      url: '/branchnetwork',
    });
  } else {
    return axios({
      method: 'GET',
      url: '/branchnetwork/search?q=' + q,
    });
  }
}

export function branchnetworkGetHeading(id) {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: '/branchnetwork/get-heading/' + id,
  });
}

export function branchnetworkStatsService() {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: '/branchnetwork/stats',
  });
}
